import React from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import constants from 'utils/constants';
import {styleJsonToCssStmt} from 'utils/utils';
export default function ChallengeDetailDescription({
  description
}) {
  let descriptionStyle = styleJsonToCssStmt(description?.style);
  let wrapperStyle = styleJsonToCssStmt(description?.wrapper_style);
  return (
    <ChallengeDescriptionBlock>
      {description?.type === 'image' && (
        <ChallengeDescriptionImageblock wrapperstyle={wrapperStyle}>
          {description?.link || description?.path ? (
            description?.link ? (
              <a href={description?.link} target={"_blank"}>
                <ChallengeDescriptionImg descriptionstyle={descriptionStyle} src={`${constants.imagePath}/campaign_description_img/${description.filename}`}/>
              </a>
            ) : (
              <Link to={description?.path}>
                <ChallengeDescriptionImg descriptionstyle={descriptionStyle} src={`${constants.imagePath}/campaign_description_img/${description.filename}`}/>
              </Link>
            )
          ) : (
            <ChallengeDescriptionImg descriptionstyle={descriptionStyle} src={`${constants.imagePath}/campaign_description_img/${description.filename}`}/>
          )}
          
        </ChallengeDescriptionImageblock>
      )}
      {
        description?.type === 'gif' && (
          <ChallengeDescriptionImageblock wrapperstyle={wrapperStyle}>
            <ChallengeDescriptionImg descriptionstyle={descriptionStyle} src={`${constants.imagePath}/campaign_description_img/${description.filename}`}/>
          </ChallengeDescriptionImageblock>
        )
      }
      {description?.type === 'text_button' && (
        <ProductInfoBtnBlock wrapperstyle={wrapperStyle}>
        {description?.link ? (
          <ProductLinkBtn btnstyle={descriptionStyle} href={description?.link} target={"_blank"}>{description?.text}</ProductLinkBtn>
        ) : (
          <ProductPathBtn btnstyle={descriptionStyle} to={description?.path}>{description?.text}</ProductPathBtn>
        )}
        </ProductInfoBtnBlock>
      )}
    </ChallengeDescriptionBlock>
  )
}

const ChallengeDescriptionBlock = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 calc(100vw  * (20 / 375));
`;

const ChallengeDescriptionImageblock = styled.div`
  width: 100%;
  ${({wrapperstyle})=>wrapperstyle}
`;

const ChallengeDescriptionImg = styled.img`
  width: 100%;
  image-rendering: -moz-crisp-edges;        
  image-rendering: -o-crisp-edges;         
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;
  object-fit: contain; 
  ${({descriptionstyle})=>descriptionstyle} 
`;

const ProductInfoBtnBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: calc(100vw * (26 / 375)) calc(100vw * (25 / 375)) calc(100vw * (26 / 375)) calc(100vw * (25 / 375)); 

  ${({wrapperstyle})=>wrapperstyle}
`;

const buttonStyle = css`
  text-align: center;
  width: 100%;
  font-size: calc(100vw * (18 / 375));
  font-weight: 700;
  padding: calc(100vw * (18 / 375)) 0;
  border-radius: calc(100vw * (8 / 375));
`;

const ProductLinkBtn = styled.a`
  ${buttonStyle};
  background: #dbdbdb; 
  ${({btnstyle})=>btnstyle}
`;
const ProductPathBtn = styled(Link)`
  ${buttonStyle};
  background: #dbdbdb;
  ${({btnstyle})=>btnstyle}
`;
